import React, { Component, useState } from "react";
import { Redirect } from "react-router-dom";
import { Input, CustomInput, Button, Alert } from "reactstrap";
import axios from "axios";
import { history } from "../../history";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { URL_Login } from "../Services/loginService";
import { URL_Doctor } from "../Services/doctorService.js";
import { formLocalStorage } from "../Models/ClassLocalStorage";
import validator from "validator";
import { Link } from "react-router-dom";
import { TypeCompany } from "../Utils/Enuns/TypeCompany";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import PackageHandler from "../../utils/PackageHandler.js";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  render() {
    const { error } = this.props;

    if (error) {
      return <Redirect to="/notfound" />;
    }
    return this.props.children;
  }
}

class FormLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      formLogin: {
        email: "",
        passwordLogin: "",
      },
      formLocalStorage,
      loading: false,
      errors: {},
      hiddenPass: true,
    };
  }

  validateOnChange = (e, field) => {
    const { formLogin } = this.state;
    formLogin[field] = e.target.value;
    this.setState({ formLogin });
    this.validator();
  };

  validator() {
    let isError = 0;
    const dados = this.state.formLogin;
    const result = validator.isEmail(dados.email);
    const errors = {};

    if (!dados.email || result == false) {
      isError++;
      errors.emailError = true;
    } else errors.emailError = false;

    if (!dados.passwordLogin) {
      isError++;
      errors.passwordError = true;
    } else errors.passwordError = false;

    this.setState({ errors });
    return isError;
  }

  onSubmit = async () => {
    if (this.validator() == 0) {
      this.setState({ loading: true });
      const { formLogin } = this.state;
      const map = {
        email: formLogin.email,
        password: formLogin.passwordLogin,
      };
      await axios
        .post(`${URL_Login}/authenticate`, map)
        .then(async (resp) => {
          const { data } = resp;
          if (data.message == "user false") {
            toast.error("Usuário não Localizado!", {
              position: "top-right",
              pauseOnFocusLoss: false,
            });
          } else if (data.message == "password false") {
            toast.error("Senha Incorreta!", {
              position: "top-right",
              pauseOnFocusLoss: false,
            });
          } else if (
            data.message == "blocked access" ||
            data.message == "access waiting" ||
            data.message == "awaiting payment"||
            data.message=="blocked access provider"
          ) {
            if (data.message == "awaiting payment") {
              toast.warning(
                "Pagamento não localizado! Redirecionando para o nosso financeiro.",
                { position: "top-right", pauseOnFocusLoss: false }
              );
              setTimeout(this.redirectWhatsApp, 5000);
            } else if (data.message == "blocked access") {
              toast.warning(
                "Por favor, entre em contato com o setor financeiro!",
                {
                  position: "top-right",
                  pauseOnFocusLoss: false,
                }
              );
              setTimeout(this.redirectWhatsApp, 5000);
            }  else if(data.message == "blocked access provider"){
              toast.warning(
                "O acesso do profissional se encontra inativo do sistema!",
                {
                  position: "top-right",
                  pauseOnFocusLoss: false,
                }
              );
            }
            else {
              toast.warning(
                "Por favor, entre em contato com o setor financeiro!",
                {
                  position: "top-right",
                  pauseOnFocusLoss: false,
                }
              );
              setTimeout(this.redirectWhatsApp, 5000);
            }
           
          } else {
            if (data.clinic.length > 0) {
              localStorage.setItem("app-token", JSON.stringify(data));
              localStorage.setItem(
                "ClinicData",
                JSON.stringify(data.clinic[0])
              );
              localStorage.setItem("idProfile", JSON.stringify(data.idProfile));
              localStorage.setItem(
                "TypeCompany",
                JSON.stringify(data.typeCompany)
              );
              localStorage.setItem("Plan", JSON.stringify(data.plan));

              await PackageHandler.forceBalance();

              history.push("/calendar");
            } else {
              toast.error("Usuario não Possue Vínculo com Clinicas!", {
                position: "top-center",
                pauseOnFocusLoss: false,
              });
            }
          }
        })
        .catch((e) => {
          this.setState({ loading: false });
        });
      this.setState({ loading: false });
    }
  };

  redirectWhatsApp = () => {
    window.open("https://api.whatsapp.com/send?phone=553499999893");
  };

  toggleHiddenPass() {
    this.setState({ hiddenPass: !this.state.hiddenPass });
  }

  render() {
    localStorage.removeItem("app-token");
    const { loading, errors } = this.state;
    return (
      <ErrorBoundary error={this.state.error}>
        <div
          className="navbar text-center navbar-light bg-dark navbar-expand-lg fixed-top position-sticky pl-lg-0 ng-scope"
          style={{
            height: "75px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "white",
          }}
        >
          <a href="">
            <img
              className="img-fluid"
              src="img/IGICoficialbranco.png"
              alt="Logo"
              style={{
                maxHeight: "75px",
                maxWidth: "75px",
                objectFit: "contain",
                width: "75px",
                height: "75px",
              }}
            />
          </a>
        </div>
        <div
          className="d-flex justify-content-center justify-content-sm-center justify-content-xl-start flex-row"
          style={{
            paddingTop: "64px",
            backgroundColor: "white",
            minHeight: "100vh",
          }}
        >
          <div class="d-none d-lg-block col-1 pr-0 pl-0"></div>
          <div className="col-md-12 col-lg-4">
            <div class="d-none d-lg-block col-1 pr-0 pl-0"></div>
            <div className="card-body w-100 w-lg-50 mt-4 ng-scope">
              <p className="text-center py-3">
                <h3>Olá, bem-vindo (a)</h3>
              </p>
              <form className="mb-3" name="formLogin">
                <div className="form-group" style={{ marginBottom: "8px" }}>
                  <div className="input-group with-focus">
                    <Input
                      type="email"
                      className="border-right-0"
                      placeholder="E-mail"
                      size="lg"
                      invalid={errors.emailError}
                      onChange={(e) => this.validateOnChange(e, "email")}
                      value={this.state.formLogin.email}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text text-muted bg-transparent rounded-right">
                        <em className="fa-1x icon-envelope"></em>
                      </span>
                    </div>
                    <span className="invalid-feedback">
                      Digite um e-mail válido!
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <div className="input-group with-focus">
                    <Input
                      type={this.state.hiddenPass ? "password" : "text"}
                      className="border-right-0"
                      placeholder="Senha"
                      size="lg"
                      invalid={errors.passwordError}
                      onChange={(e) =>
                        this.validateOnChange(e, "passwordLogin")
                      }
                      value={this.state.formLogin.passwordLogin}
                    />
                    <div
                      className="input-group-append"
                      onClick={() => this.toggleHiddenPass()}
                    >
                      <span
                        className="input-group-text text-muted bg-transparent"
                        style={{
                          borderRight: "none",
                          backgroundColor: "#E8F0FE",
                        }}
                      >
                        <em
                          className={
                            this.state.hiddenPass
                              ? "fas fa-eye"
                              : "fas fa-eye-slash"
                          }
                        ></em>
                      </span>
                      <span
                        className="input-group-text text-muted bg-transparent rounded-right"
                        style={{ borderLeft: "none" }}
                      >
                        <em className="fa-1x icon-lock"></em>
                      </span>
                    </div>
                    <span className="invalid-feedback">Campo obrigatório!</span>
                  </div>
                </div>
                <div className="clearfix" style={{ paddingBottom: "24px" }}>
                  <CustomInput
                    type="checkbox"
                    id="rememberme"
                    className="float-left"
                    name="remember"
                    label="Lembrar acesso"
                  ></CustomInput>
                  <div className="float-right">
                    <Link
                      style={{ fontWeight: "600" }}
                      to="resetpassword"
                      className="text-muted"
                    >
                      Esqueci minha senha
                    </Link>
                  </div>
                </div>
                <Button
                  className="btn btn-block btn-primary mt-4"
                  color="primary"
                  size="lg"
                  onClick={(e) => this.onSubmit()}
                  disabled={loading}
                  style={{ fontWeight: 600 }}
                >
                  {loading && <i className="fas fa-spinner fa-spin" />}
                  {loading && <span>Entrando...</span>}
                  {!loading && <span>Entrar</span>}
                </Button>
              </form>
              <hr />
              <GoogleOAuthProvider clientId="746932658929-avau5v67l6je7hr5ftreir6186j2ffp9.apps.googleusercontent.com">
                <LoginButtonGoogle />
              </GoogleOAuthProvider>
              <Link
                to="register"
                className="btn btn-lg btn-block btn-secondary"
                style={{ fontWeight: 600 }}
              >
                Criar conta
              </Link>
              {/* <div className="p-5 text-center">
                <span className="mr-1">&copy;</span>
                <span>2021</span>
                <span className="mx-2">-</span>
                <span>Sistema IGIC</span>
                <br />
              </div> */}
            </div>
          </div>
          <div
            className="d-none d-xl-block position-relative col px-0 col"
            style={{
              width: "600px",
              height: "520px",
              backgroundColor: "#f0f0f0",
              borderRadius: "6px",
              marginLeft: "180px",
              marginRight: "90px",
              padding: "0",
              overflow: "hidden",
            }}
          >
            <img
              src="/img/capalogin.png"
              alt="Logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                margin: "0",
                padding: "0",
                display: "block",
              }}
            />
          </div>
        </div>
      </ErrorBoundary>
    );
  }
}

function LoginButtonGoogle() {
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      if (codeResponse) {
        fetch(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${codeResponse.access_token}`,
            },
          }
        )
          .then((res) => res.json())
          .then((resp) => {
            localStorage.setItem("Register", JSON.stringify(resp));
            history.push(`/registerone`);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("Login Failed:", error);
    },
    onNonOAuthError: (e) => {
      setLoading(false);
    },
  });

  const [loading, setLoading] = useState(false);

  return (
    <Button
      className="btn btn-block btn-primary mt-3"
      color="dark"
      size="lg"
      style={{ fontWeight: 600 }}
      disabled={loading}
      onClick={() => {
        setLoading(true);
        login();
      }}
    >
      {!loading && <i className="fab fa-google mr-2" />}
      {loading && <i className="fas fa-spinner fa-spin mr-2" />}
      {loading && <span>Carregando...</span>}
      {!loading && <span>Cadastrar com o Google</span>}
    </Button>
  );
}

export default class Login extends Component {
  render() {
    return <FormLogin />;
  }
}
